var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
var FormlessContext = createContext(null);
export var useFormlessContext = function () {
    return useContext(FormlessContext);
};
export var FormlessProvider = function (props) {
    var control = props.control, setValue = props.setValue;
    var value = useMemo(function () { return ({ control: control, setValue: setValue }); }, [control, setValue]);
    return _jsx(FormlessContext.Provider, __assign({ value: value }, { children: props.children }));
};
